import { Ref } from "vue";
import { Constructor } from "../@types/shared";

import {
    DividerPartitionCode,
    DoorPartitionCode,
    GlassPartitionCode,
} from "../constants";
import { ICreateOneStrategy } from "../domain/strategies/base/creation.strategy";
import {
    InstallationDividerCreationStrategy,
    InstallationDoorCreationStrategy,
} from "../domain/strategies/creation/installation.strategy";

export class InstallationStrategiesRegistry {
    private strategies = new Map<string, Constructor<ICreateOneStrategy>>();

    constructor() {
        this.register(DividerPartitionCode, InstallationDividerCreationStrategy);  // div -> Divider
        this.register(GlassPartitionCode, InstallationDoorCreationStrategy);  // fxp -> GlassPartition
        this.register(DoorPartitionCode, InstallationDoorCreationStrategy);  // dr -> Door Partition
    }

    getStrategy = (
        partitionType: Ref<string> | "", // div | fxp | dr
    ): Constructor<ICreateOneStrategy> | null => {
        if (!partitionType) return null;
        return this.strategies.get(partitionType) || null;
    };

    private register = (
        partitionType: string, // div | fxp | dr
        strategy: Constructor<ICreateOneStrategy>,
    ) => {
        this.strategies.set(partitionType, strategy);
    };
}
